import { FC } from "react";

import { Alert, Button, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { newFeaturesCampaigns } from "constants/campaigns";
import { HelpCenter } from "constants/help-center";
import { TicketsRoutes } from "constants/tickets/TicketsRoutes";
import { useNewFeatureForAgents } from "hooks/use-new-feature-for-agents";
import { TicketSilo, getSiloByRoute } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

interface IProps {
  route: TicketsRoutes;
}

const TicketsListArchiveBanner: FC<IProps> = ({ route }) => {
  const siloFromRoute = getSiloByRoute(route);
  const {
    isNewForAgent,
    featureFlagValue: hasSeenArchiveOnboardingBanner,
    setAgentFlagCallback: setHasSeenArchiveOnboardingBanner,
  } = useNewFeatureForAgents(
    newFeaturesCampaigns.hasSeenArchiveOnboardingBanner.flag,
    newFeaturesCampaigns.hasSeenArchiveOnboardingBanner.campaignStartDate
  );

  const shouldDisplayBanner = siloFromRoute === TicketSilo.Archive && !hasSeenArchiveOnboardingBanner && isNewForAgent;

  if (!shouldDisplayBanner) {
    return null;
  }

  return (
    <Flex justifyContent="center" alignItems="center" margin={withVar(SpacingToken.Spacing5)}>
      <Alert onClose={setHasSeenArchiveOnboardingBanner}>
        <Text>
          Move tickets to the Archive to exclude solved, closed, old, or irrelevant tickets from the main dashboard.
          Remove clutter and make the handling process quicker and more efficient.&nbsp;
          <Button href={HelpCenter.ARCHIVE_TRASH_AND_SPAM_FOLDERS} target="_blank" kind="link">
            Learn more
          </Button>
        </Text>
      </Alert>
    </Flex>
  );
};

export default TicketsListArchiveBanner;
